import { supabase } from './supabaseClient';

const SUPABASE_URL = process.env.VUE_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.VUE_APP_SUPABASE_ANON_KEY;

// One session ID per page load
export const sessionId = crypto.randomUUID();

// Check if we're in production mode to avoid sending test data from development environments
const isProduction = process.env.NODE_ENV === 'production' && window.location.hostname === 'greenslash.dev';

let activeSeconds = 0;
let clockStart = null;

function startClock() {
  if (clockStart === null) {
    clockStart = Date.now();
  }
}

function pauseAndAccumulate() {
  if (clockStart !== null) {
    activeSeconds += (Date.now() - clockStart) / 1000;
    clockStart = null;
  }
}

// Uses keepalive so the request survives tab close / beforeunload.
// Upserts by session_id so repeated flushes (tab hide/show cycles) update
// rather than insert duplicate rows.
function flushSession() {
  if (!isProduction) return;
  pauseAndAccumulate();
  const secs = Math.round(activeSeconds);
  if (secs <= 0) return;

  fetch(`${SUPABASE_URL}/rest/v1/sessions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      'Prefer': 'resolution=merge-duplicates,return=minimal',
    },
    body: JSON.stringify({ session_id: sessionId, active_seconds: secs }),
    keepalive: true,
  }).catch(() => {});
}

// Called once from App.vue mounted()
export function initSessionTracking() {
  startClock();

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      flushSession();
    } else {
      // Tab visible again — restart accumulation from now
      clockStart = Date.now();
    }
  });

  window.addEventListener('beforeunload', flushSession);
}

export async function trackVisit() {
  if (!isProduction || !supabase) return;
  try {
    await supabase.from('visits').insert({ session_id: sessionId });
  } catch (_) { /* silently ignore tracking errors */ }
}

export async function trackProjectClick(projectName) {
  if (!isProduction || !supabase) return;
  try {
    await supabase.from('project_clicks').insert({
      session_id: sessionId,
      project_name: projectName,
    });
  } catch (_) { /* silently ignore tracking errors */ }
}
